import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import Parallax from "react-rellax";
import * as historys from "../../../historys";
import * as plan from "../../../constants/plan";
import * as screenActions from "../../../common/status/screen/actions";
import ScrollToTopOnMount from "../../../common/scrollToTopOnMount/ScrollToTopOnMount";
import styles from "./styles";
import { TRANSACTION_TITLE } from "../../../constants/title";
import { setHeadDefault } from "../../../constants/sns";

/**
 * 特定商法取引法画面.
 */
const Transaction = () => {
    /** CSS. */
    const classes = styles();

    /** Hooks. */
    const dispatch = useDispatch();
    const history = useHistory();

    /** 会員プランの金額. */
    const planPrice = useSelector(state => state.Member.planPrice);

    /**
     * 画面描画時に実行する処理.
     */
    useEffect(() => {
        dispatch(screenActions.transaction());

        // head設定.
        setHeadDefault(TRANSACTION_TITLE);
    }, [dispatch]);

    return (
        <div>
            {/* 遷移時に画面トップに移動. */}
            <ScrollToTopOnMount />
            <Parallax className="l-planetBg rellax" speed={2}></Parallax>
            <div className="l-main">
                <div className="c-static">
                    <div className="c-static__logo"><img src="./assets/images/logo-brand-imagination.png" alt="TSUBURAYA imagination" /></div>
                    <div className="c-static__box">
                        <div className="c-static__boxTop">
                            <div className="c-static__boxTopTtl">特定商取引法に基づく表記</div>
                        </div>
                        <ul className="c-static__wrap">
                            <li className="c-static__item">
                                <div className="c-static__dtl"><b>■販売業者の名称及び所在地</b><br/>株式会社 円谷プロダクション<br/>（〒150-0036 東京都渋谷区南平台町16−17 渋谷ガーデンタワー24F）<br/>代表者：代表取締役社長　永竹 正幸<br/><br/><b>■お問合せ窓口</b><br/>カスタマーサポート<br/>お問い合わせフォーム<br/><a className="c-static__dtlLink" href="https://account.m-78.jp/Account/Home/ContactUs?redirecturl=https%3A%2F%2Fimagination.m-78.jp" target="_blank" rel="noreferrer">https://account.m-78.jp/Account/Home/ContactUs</a><br/>受付：10:00～18:00（年中無休）<br/><br/><b>■利用料金</b><br/>{"スタンダード　" + Number(planPrice[plan.STANDARD]) + "円(税込)/月　プレミアム　" + Number(planPrice[plan.PREMIUM]).toLocaleString() + "円（税込）/年"}<br/><br/><b>■利用料金以外の手数料等</b><br/>本サイト利用及びデジタルコンテンツのダウンロードの際に発生するパケット通信料<br/><br/>【レンタルをする場合】<br/>月額料金に加えて、レンタルのお支払いページに表示されるレンタル料金のお支払いが必要です。<br/><br/><b>■お支払い方法、お支払い時期</b><br/>＜クレジットカード決済＞<br/>VISA、MASTER がご利用可能です。お支払い時期は、各決済事業者と消費者との契約によります。<br/><br/><b>■提供時期</b><br/>個別に案内がある場合を除き､所定の手続の終了後､直ちにご利用いただけます。<br/><br/><b>■返品</b><br/>商品の性質上､返品はございません。<br/>コンテンツに欠陥があり利用できない等の場合、あらためて欠陥のないコンテンツを提供致します。上記連絡先へお問い合わせください。<br/><br/><b>■推奨環境</b><br/>当社のWebサイトに推奨環境の説明ページを設けております。詳細は<span className={classes.clickable + " c-static__dtlLink"} onClick={() => historys.historyEnvironment(history)}>こちら</span>をご参照下さい。<br/><br/>以下の事項は､当該事項が存在する場合のみ､各サービスでご案内しております。<br/>□申込の有効期限<br/>□対応機種</div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Transaction;
